<template>
  <div class="student-data__component">
    <div v-if="student && states">
      <edit-student-data-modal
        :student="student"
        v-if="showEditStudentDataModal"
        @close="closeEditStudentData"
      />
      <reset-password
        v-if="showResetPasswordModal"
        @close="handleResetPasswordModal"
      />
      <div class="student-view__header-title">
        <h4 class="left-align">
          <strong>Dados do aluno</strong>
        </h4>
        <div class="dropdown">
          <button
            class="btn btn-primary dropdown-toggle"
            type="button"
            id="student-options"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            Ações
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="student-options">
            <li>
              <a @click="openEditStudentData">
                Editar as informações
              </a>
            </li>
            <li>
              <a v-if="student.qb_id" target="_blank"
                 :href="`//vendas.querobolsa.com.br/#/user/${student.qb_id}`"
              >
                Exibir no OPA
              </a>
            </li>
            <li>
              <a v-if="student.qb_id" target="_blank"
                 :href="`//vendas.querobolsa.com.br/impersonate/${student.qb_id}`"
              >
                Impersonar no Quero Bolsa
              </a>
            </li>
            <li>
              <a @click="impersonateStudentInQP()">
                Impersonar no Quero Pago
              </a>
            </li>
            <li>
              <a @click="handleResetPasswordModal">
                Enviar e-mail de reset de senha
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr class="divider divider--spaced-l-bottom">
      <div class="student-view__panel-content">
        <div class="panel__row">
          <div class="panel__col">
            <p class="panel__title">
              Nome
            </p>
            <p>{{ student.name }}</p>
          </div>
          <div class="panel__col">
            <p class="panel__title">
              CPF
            </p>
            <p>{{ student.cpf }}</p>
          </div>
          <div class="panel__col">
            <p class="panel__title">
              E-mail
            </p>
            <p>{{ student.email }}</p>
          </div>
          <div class="panel__col">
            <p class="panel__title">
              Telefone
            </p>
            <p>{{ student.formatted_cellphone | formatCellphone }}</p>
          </div>
          <div class="panel__col">
            <p class="panel__title">
              Id
            </p>
            <p>{{ student.id }}</p>
          </div>
        </div>
        <div class="collapse" id="extraStudentData">
          <div class="panel__row">
            <div class="panel__col">
              <p class="panel__title">
                Nascimento
              </p>
              <p v-if="!student.birthday">
                -
              </p>
              <p v-else>
                {{ student.birthday | formatDate }}
              </p>
            </div>
            <div v-if="states" class="panel__col">
              <p class="panel__title">
                Estado
              </p>
              <p>{{ studentState }}</p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Cidade
              </p>
              <p>{{ studentCity }}</p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                RG
              </p>
              <p v-if="!student.identity_card">
                -
              </p>
              <p v-else>
                {{ student.identity_card }}
              </p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Orgão expeditor
              </p>
              <p v-if="!student.identity_card_emissor">
                -
              </p>
              <p v-else>
                {{ student.identity_card_emissor }}
              </p>
            </div>
          </div>
          <div class="panel__row">
            <div class="panel__col">
              <p class="panel__title">
                Endereço
              </p>
              <p v-if="!student.address">
                -
              </p>
              <p v-else>
                {{ student.address }}
              </p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Número
              </p>
              <p v-if="!student.address">
                -
              </p>
              <p v-else>
                {{ student.address_number }}
              </p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Complemento
              </p>
              <p v-if="!student.address_complement">
                -
              </p>
              <p v-else>
                {{ student.address_complement }}
              </p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Bairro
              </p>
              <p v-if="!student.neighborhood">
                -
              </p>
              <p v-else>
                {{ student.neighborhood }}
              </p>
            </div>
          </div>
          <div class="panel__row">
            <div class="panel__col">
              <p class="panel__title">
                CEP
              </p>
              <p v-if="!student.postal_code">
                -
              </p>
              <p v-else>
                {{ student.postal_code }}
              </p>
            </div>
            <div class="panel__col">
              <p class="panel__title">
                Sexo
              </p>
              <p v-if="!student.gender">
                -
              </p>
              <p v-else>
                {{ student.gender === 'M' ? 'Masculino' : (student.gender === 'F' ? 'Feminino' : '-') }}
              </p>
            </div>
          </div>
        </div>
        <div class="show-more--container">
          <button class="btn btn-link collapsed show-more"
                  type="button"
                  data-toggle="collapse"
                  data-target="#extraStudentData"
                  aria-expanded="false"
                  aria-controls="extraStudentData"
          >
            <div class="colalapse--opened">
              Mostrar menos
              <span class="glyphicon glyphicon-menu-up" aria-hidden="true"></span>
            </div>
            <div class="colalapse--closed">
              Mostrar mais
              <span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span>
            </div>
          </button>
        </div>
      </div>
    </div>
    <loading v-else class="cards__loading" full-screen="false" size="small" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'components/Loading';
import AdminService from 'services/AdminService';
import EditStudentDataModal from '../modals/EditStudentDataModal';
import ResetPassword from './ResetPassword';

export default {
  data() {
    return {
      showEditStudentDataModal: false,
      showResetPasswordModal: false,
    };
  },
  components: {
    Loading,
    EditStudentDataModal,
    ResetPassword,
  },
  computed: {
    ...mapState([
      'student',
      'states',
      'cities',
    ]),
    studentState() {
      return this.student.state_id ? this.findStudentState() : '-';
    },
    studentCity() {
      return (this.student.city_id && this.cities) ? this.findStudentCity() : '-';
    },
  },
  methods: {
    findStudentState() {
      const locatedState = this.states.find(state => state.id === this.student.state_id);
      return locatedState ? locatedState.name : 'desconhecido';
    },
    findStudentCity() {
      const locatedCity = this.cities.find(city => city.id === this.student.city_id);
      return locatedCity ? locatedCity.name : 'desconhecido';
    },
    openEditStudentData() {
      this.showEditStudentDataModal = true;
    },
    closeEditStudentData() {
      this.showEditStudentDataModal = false;
    },
    handleResetPasswordModal() {
      this.showResetPasswordModal = !this.showResetPasswordModal;
    },
    impersonateStudentInQP() {
      AdminService.impersonateStudentInQP(this.student.id)
        .then(() => {
          window.open(`${this.$qpFrontHost}?impersonating=true`, '_blank');
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao impersonar aluno, tente novamente mais tarde');
        });
    },
  },
};
</script>
